import React from 'react'

import * as styles from './become_a_xeal_partner.module.scss'
// import Reseller from '../../../forms/Reseller/Reseller'
import { LinkCta, Button } from 'common'
// import Modal from 'common/Modal'
import ResellerModal from '../../../modals/ResellerModal'

export default function BecomeAXealPartner({ title, subtitle, ctas }) {
  return (
    <LinkCta
      className={styles.section}
      title={title}
      titleAs="h1"
      subtitle={subtitle}
      customCta={() => <CustomCta text={ctas[0].text} />}
    />
  )
}

const CustomCta = ({ text }) => {
  return (
    <div style={{ marginTop: 'var(--sp-7)' }}>
      <ResellerModal arrow text={text} btn />
    </div>
  )
}
